import PropTypes from 'prop-types';
import React from 'react';

import Authorization from '@appComponents/Authorization';
import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import {getLink} from '@appComponents/Link';
import {IconEdit} from '@appComponents/IconCollection';
import {renderNameOfRowColumn} from '@utils/tableHelpers';
import {CONTACT_PERSON, PRODUCTION_COMPANY} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';

const contactPersonAuthorizationObject = {
    [PRODUCTION_COMPANY]: SECURITY_PRIVILEGES_READ,
    [CONTACT_PERSON]: SECURITY_PRIVILEGES_READ,
};

export const rowRenderer = (column, row, props) => {
    const {id} = props;

    switch (column) {
        case 'id':
        case 'name':
            return (
                <LinkWithAuthorization
                    authorization={contactPersonAuthorizationObject}
                    link={{
                        name: 'productionCompanies.contactPersons.edit',
                        params: {id: id, contactPersonId: row.id},
                    }}
                >
                    {row[column]}
                </LinkWithAuthorization>
            );
        case 'contact_person_type':
            return (
                <div>
                    {renderNameOfRowColumn(row, column)}
                </div>
            );
        case 'actions': {
            return (
                <Authorization authorization={contactPersonAuthorizationObject}>
                    <div className='actions-list-icon'>
                        <IconEdit
                            link={getLink('productionCompanies.contactPersons.edit', {
                                id: id,
                                contactPersonId: row.id,
                            })}
                            size='large'
                            resource={CONTACT_PERSON}
                        />
                    </div>
                </Authorization>
            );
        }
        default: {
            return null;
        }
    }
};

rowRenderer.propTypes = {
    id: PropTypes.string.isRequired,
};

rowRenderer.displayName = 'rowRenderer';
